import globalEventBus from 'toxilibs/event_bus_queued.js'

let eventBus = globalEventBus('way verifier')


let way
let lastWayLength


//FIXME this lastWayLength is useful to handle cases where a card does nothing.
//But it must exist a more elegant way

eventBus.on('player updated by God', function () {
    lastWayLength = false
})


eventBus.on('way updated', function (_way) {
    way = _way
    if (way.length === 1 || (lastWayLength && lastWayLength === way.length)) {
        eventBus.emit('way completed')
    }
    lastWayLength = way.length
})


let movesDone

eventBus.on('player updated by God', function () {
    movesDone = 0
})


eventBus.on('player moved', function (targetCell, beforeToricCoords) {
    movesDone += 1
    emitResult(isOnCorrectWay(targetCell, beforeToricCoords))
})


eventBus.on('player collided', function (targetCoords, direction) {
    movesDone += 1
    emitResult(isCollisionExpected(targetCoords, direction))
})



function emitResult (isSuccessful) {
    if (isSuccessful) {
        emitSuccess()
    } else {
        emitFailure()
    }
}


function emitFailure () {
    eventBus.emit('wrong way taken', movesDone) //FIXME: use movesDone for analytics
}


function emitSuccess () {
    eventBus.emit('line correctly interpreted', way[movesDone].line)
    if (movesDone === way.length - 1) {
        eventBus.emit('way completed')
    }
}



function isOnCorrectWay (targetCell, beforeToricCoords) {
    let nextGoalCell = way && movesDone < way.length && way[movesDone].cell

    return nextGoalCell &&
        sameToricCoords(way[movesDone].beforeToricCoords, beforeToricCoords) &&
        targetCell.x === nextGoalCell.x &&
        targetCell.y === nextGoalCell.y
}


function isCollisionExpected (targetCoords, direction) {
    let nextMove = way && movesDone < way.length && way[movesDone]

    return nextMove &&
        nextMove.direction === direction &&
        nextMove.collidedWith.x === targetCoords.x &&
        nextMove.collidedWith.y === targetCoords.y
}



function sameToricCoords (toricCoordsA, toricCoordsB) {
    if (toricCoordsA) {
        if (toricCoordsB) {
            return toricCoordsA.x === toricCoordsB.x && toricCoordsA.y === toricCoordsB.y
        } else {
            return false
        }
    } else {
        return !toricCoordsB
    }
}



